import { PosDocumentsStepModalComponent } from './pos-documents-step-modal.component';
import { DocumentsStepModule } from './../../views/credit-request/components/documents-step/documents-step.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [PosDocumentsStepModalComponent],
  imports: [CommonModule, DocumentsStepModule],
})
export class PosDocumentsStepModalModule {}
